<template>
  <div id="app">
    <router-view />
    <GenerationStopButton />
  </div>
</template>

<script>
import jwt_decode from 'jwt-decode'
import VConsole from 'vconsole';
import request from '@/utils/request'
import GenerationStopButton from '@/components/GenerationStopButton'

export default {
  name: 'App',
  components: {
    GenerationStopButton
  },
  async created() {
    try {
      const data = await request({
        url: '/auth-service/verifycodes/get_verifycode?fromType=verify_ip',
        method: 'get'
      })
      const countryCode = data.data.data.countryCode

      this.$i18n.locale = countryCode === 'CN' ? 'zh' : 'en'
      this.$eventHub.$emit('changeLanguage', this.$i18n.locale)
      localStorage.setItem('locale', this.$i18n.locale)
    } catch (error) {
      this.$i18n.locale = 'en'
      this.$eventHub.$emit('changeLanguage', this.$i18n.locale)
      localStorage.setItem('locale', this.$i18n.locale)
    }
  },
  mounted() {
    // if (process.env.NODE_ENV != 'production') {
    //   const vConsole = new VConsole();
    // }
  },
  methods: {
    isEmpty(value) {
      return (
        value === undefined ||
        value === null ||
        (typeof value === 'object' && Object.keys(value).length === 0) ||
        (typeof value === 'string' && value.trim().length === 0)
      )
    }
  }
}
</script>
<style>
html,
body,
#app {
  width: 100%;
  height: 100%;
  overflow: hidden !important;
}
.vc-switch {
  right: 20px !important;
  bottom: 200px !important;
}
</style>
